import { IDcotorChatSessionItem } from '@schemas/workstation';
import { DOCTOR_JOBTYPE } from '@/schemas/doctor';
import * as services from '@services/index';

interface State {
  messageList: IDcotorChatSessionItem[];
  newMessage: boolean;
}

const initState: State = {
  messageList: [],
  newMessage: false
};

const workstation = {
  state: initState,

  reducers: {
    updateState(state: State, payload) {
      return {
        ...state,
        ...payload
      };
    }
  },

  effects: (_dispatch) => ({
    async getMessageList({ jobType, hideLoading }) {
      try {
        const result = await services.workstation.queryDoctorChatSessions({
          hideLoading,
          changeListOrder: jobType !== DOCTOR_JOBTYPE.ASSISTANT,
          changeContent: '[预开方]'
        });
        this.updateState({
          messageList: result,
          newMessage: result?.find((item) => {
            return item?.unreadCount > 0;
          })
        });
      } catch (ignore) {
        // ignore
      }
    }
  })
};

export default workstation;
